class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);

document.addEventListener('DOMContentLoaded', function() {
  const mobileSearchIcon = document.querySelector('#dT_TopStickySearchBtn');
  const searchModal = document.querySelector('#dT_top-sticky');
  
  if (mobileSearchIcon && searchModal) {
    mobileSearchIcon.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      // Create a synthetic click event on a child element to trigger the modal's open method
      const closeButton = searchModal.querySelector('.modal_toggle-close');
      if (closeButton) {
        // Simulate clicking from inside the details element
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });
        closeButton.dispatchEvent(clickEvent);
      } else {
        // Fallback: try calling the open method directly if it exists
        if (typeof searchModal.open === 'function') {
          searchModal.open(e);
        } else {
          searchModal.setAttribute('open', '');
          searchModal.classList.add('active');
        }
      }
    });
  }
});
